import type { ProviderContext } from "notistack";
import { useSnackbar } from "notistack";

// eslint-disable-next-line import/no-mutable-exports
export let useSnackbarRef: ProviderContext;

export const SnackbarUtilsConfigurator = () => {
  // eslint-disable-next-line react-hooks/globals
  useSnackbarRef = useSnackbar();
  return null;
};
